import { GROUP_DEFINITIONS, ROLE_OPTIONS, SOURCE_EVENT_GROUPS } from './my_tasks.data.js';

export const create_new_task_form = () => ({ task: '', detail: '', owner: 'Compliance Officer - Pearl Naidoo', category: 'Delegated by me', assignee: '', timing: '', status_sla: 'Upcoming', due: '3 days', escalation_level: 'None', source_event: 'None - standalone task', linked_record_id: '', record_label: '', points_to: 'Procurement', attribute_approval: true, attribute_evidence: true });
export const create_edit_task_form = () => ({ task: '', detail: '', owner: 'Compliance Officer - Pearl Naidoo', category: 'Reviews due', timing: '', status_sla: 'Upcoming', due: '3 days', escalation_level: 'None', source_event: 'None - standalone task', linked_record_id: '', record_label: '', record_module: 'Controls', attribute_approval: true, attribute_evidence: true });
export const new_task_owner_options = ['Compliance Officer - Pearl Naidoo', 'CFO - M. Khan', 'SCM Manager - J. Daniels', 'HR Manager - L. Botha', 'Legal - T. Mokoena', 'Accounting Officer - Dr S. Maluleke'];
export const new_task_category_options = ['Approvals', 'Reviews due', 'Evidence requests', 'Escalations', 'Delegated by me'];
export const new_task_status_options = ['Due today', 'Overdue', 'Upcoming', 'Blocked / awaiting others'];
export const new_task_escalation_options = ['None', 'L1 - Manager', 'L2 - Exec', 'L3 - Regulator'];
export const new_task_source_event_options = ['None - standalone task', 'Procurement deviation logged - REQ-204', 'POPIA breach reported - INC-2207', 'Supplier tax certificate expired - SUP-ABC', 'AGSA audit evidence requested - AUD-FY26', 'Renewal above CFO threshold - CTR-118', 'Conflict of interest declared - COI-44', 'Training overdue - annual gate - TRN-POPIA'];
export const new_task_domain_options = ['Procurement', 'Finance', 'Contracts', 'Employees', 'Training', 'Policies', 'Risks', 'Incidents', 'Audits', 'Corrective actions', 'Regulatory calendar', 'Conflicts', 'Data privacy', 'Controls'];

const active_owner_lookup = { compliance_officer: 'Pearl Naidoo', cfo: 'Lebo Mokoena', scm_manager: 'Nandi Dlamini', hr_manager: 'Sibusiso Nkosi', legal: 'Amina Patel', accounting_officer: 'Thabo Maseko' };

function build_task_lookup(tasks) {
  const lookup = {};
  tasks.forEach((task) => {
    Reflect.set(lookup, task.id, task);
  });
  return lookup;
}

function status_matches_filter(active_filter, status) {
  const filter_status_map = {
    due_today: 'Due today',
    overdue: 'Overdue',
    blocked: 'Blocked',
    completed: 'Completed'
  };
  if (active_filter === 'all') return true;
  return status === Reflect.get(filter_status_map, active_filter);
}

function count_tasks_by_status(tasks, status) {
  return tasks.filter((task) => task.status === status).length;
}

function filter_definition(id, label, count) {
  return { id, label, count };
}

function metric_definition(id, label, value, subtitle, tone) {
  return { id, label, value, subtitle, tone };
}

function resolve_group_definition(view_mode, group_id) {
  return Reflect.get(Reflect.get(GROUP_DEFINITIONS, view_mode) || GROUP_DEFINITIONS.category, group_id);
}

function edit_task_source_event(task_id) {
  const source_event_map = {
    1: 'Procurement deviation logged - REQ-204',
    2: 'Supplier tax certificate expired - SUP-ABC',
    3: 'Conflict of interest declared - COI-44',
    4: 'Training overdue - annual gate - TRN-POPIA',
    5: 'Renewal above CFO threshold - CTR-118',
    6: 'AGSA audit evidence requested - AUD-FY26',
    7: 'POPIA breach reported - INC-2207'
  };
  const source_event = Reflect.get(source_event_map, task_id) || 'None - standalone task';
  return source_event;
}

function edit_task_record_module_value(task_id) {
  const record_module_map = {
    1: 'Policies',
    2: 'Controls',
    3: 'Conflicts',
    4: 'Policies',
    5: 'Corrective actions',
    6: 'Audits',
    7: 'Data privacy'
  };
  const record_module = Reflect.get(record_module_map, task_id) || 'Controls';
  return record_module;
}

function edit_task_owner_label(role_label, active_owner) {
  const owner_label = `${role_label} - ${active_owner}`;
  return owner_label;
}

function edit_task_record_values(task) {
  const record_values = {
    source_event: edit_task_source_event(task?.id),
    record_module: edit_task_record_module_value(task?.id),
    linked_record_id: (task.tags || [])[0] || '',
    record_label: task.subtitle || ''
  };
  return record_values;
}

function edit_task_escalation_level(status) {
  const escalation_level = status === 'Overdue' ? 'L1 - Manager' : 'None';
  return escalation_level;
}

function build_edit_task_form(task, role_label, active_owner, methods) {
  const status_sla = methods.edit_task_status_label(task);
  const escalation_level = edit_task_escalation_level(task.status);
  const record_values = edit_task_record_values(task);
  const edit_task_form = {
    task: task.title || '',
    detail: task.subtitle || '',
    owner: edit_task_owner_label(role_label, active_owner),
    category: methods.edit_task_category_label(task),
    timing: '',
    status_sla,
    due: task.due || '3 days',
    escalation_level,
    source_event: record_values.source_event,
    linked_record_id: record_values.linked_record_id,
    record_label: record_values.record_label,
    record_module: record_values.record_module,
    attribute_approval: true,
    attribute_evidence: true
  };
  return edit_task_form;
}

function edited_task_status(status_sla) {
  const status_map = {
    'Due today': 'Due today',
    Overdue: 'Overdue',
    'Blocked / awaiting others': 'Blocked'
  };
  const task_status = Reflect.get(status_map, status_sla) || 'On track';
  return task_status;
}

function edited_task_status_class(status_sla) {
  const status_class_map = {
    'Due today': 'bg-warning-subtle text-warning-emphasis',
    Overdue: 'bg-danger-subtle text-danger-emphasis'
  };
  const task_status_class = Reflect.get(status_class_map, status_sla) || 'bg-success-subtle text-success-emphasis';
  return task_status_class;
}

export const my_tasks_computed = {
  task_lookup() { return build_task_lookup(this.tasks); },
  role_label() { return this.roles.find((role) => role.id === this.active_role)?.label || 'Compliance Officer'; },
  roles() { return ROLE_OPTIONS; },
  role_tasks() { return this.tasks.filter((task) => (task.roles || []).includes(this.active_role)); },
  visible_tasks() { return this.role_tasks.filter((task) => status_matches_filter(this.active_filter, task.status)); },
  visible_filters() {
    const counts = {
      all: this.role_tasks.length,
      due_today: count_tasks_by_status(this.role_tasks, 'Due today'),
      overdue: count_tasks_by_status(this.role_tasks, 'Overdue'),
      blocked: count_tasks_by_status(this.role_tasks, 'Blocked'),
      completed: count_tasks_by_status(this.role_tasks, 'Completed')
    };
    return [
      filter_definition('all', 'All', counts.all),
      filter_definition('due_today', 'Due today', counts.due_today),
      filter_definition('overdue', 'Overdue', counts.overdue),
      filter_definition('blocked', 'Blocked', counts.blocked),
      filter_definition('completed', 'Completed', counts.completed)
    ];
  },
  visible_metrics() {
    return [
      metric_definition('due_today', 'Due today', String(count_tasks_by_status(this.role_tasks, 'Due today')), 'On the clock', 'amber'),
      metric_definition('overdue', 'Overdue', String(count_tasks_by_status(this.role_tasks, 'Overdue')), 'Past SLA', 'red'),
      metric_definition('blocked', 'Blocked / waiting', String(count_tasks_by_status(this.role_tasks, 'Blocked')), 'Awaiting others', 'green'),
      metric_definition('completed', 'Completed', String(count_tasks_by_status(this.role_tasks, 'Completed')), 'This cycle', 'green')
    ];
  },
  active_role_label() { return this.role_label; },
  active_owner() { return Reflect.get(active_owner_lookup, this.active_role) || 'Pearl Naidoo'; },
  visible_groups() {
    return ['reviews', 'evidence', 'escalations'].map((group_id) => {
      const group_tasks = this.visible_tasks.filter((task) => task.group === group_id);
      const definition = resolve_group_definition(this.view_mode, group_id);
      return group_tasks.length ? { id: `${this.view_mode}-${group_id}`, title: definition.title, subtitle: definition.subtitle, icon: definition.icon, tasks: group_tasks, badge: definition.badge } : null;
    }).filter(Boolean);
  },
  source_event_groups() { return SOURCE_EVENT_GROUPS.map((group) => ({ ...group, tasks: group.task_ids.map((task_id) => Reflect.get(this.task_lookup, task_id)).filter(Boolean) })); },
  active_drawer() { return this.drawer_catalog[this.active_drawer_key] || null; },
  active_drawer_footer_primary_actions() { const actions = this.active_drawer?.footer_actions || []; return actions.some((action) => action.position) ? actions.filter((action) => action.position === 'left') : []; },
  active_drawer_footer_actions() { const actions = this.active_drawer?.footer_actions || []; return actions.some((action) => action.position) ? actions.filter((action) => action.position !== 'left') : actions; }
};

export const my_tasks_methods = {
  task_is_owned_by_active_role(task) { return (task.roles || []).includes(this.active_role); },
  navigate_to_route(route_name) { if (route_name) this.$router.push({ name: route_name }); },
  open_task(task) { if (task?.route_name) return this.navigate_to_route(task.route_name); this.open_drawer(task?.drawer_key); },
  open_filter(filter_id) { this.set_filter(filter_id); },
  open_new_task_modal() { this.show_new_task_modal = true; },
  close_new_task_modal() { this.show_new_task_modal = false; },
  edit_task_category_label(task) { return { approvals: 'Reviews due', evidence: 'Evidence requests', escalations: 'Escalations' }[task?.category] || 'Reviews due'; },
  edit_task_status_label(task) { return task?.status === 'Due today' ? 'Due today' : task?.status === 'Overdue' ? 'Overdue' : task?.status === 'Blocked' ? 'Blocked / awaiting others' : 'Upcoming'; },
  edit_task_source_label(task) { return edit_task_source_event(task?.id); },
  edit_task_record_module(task) { return edit_task_record_module_value(task?.id); },
  open_edit_task_modal(task) { if (!task) return; this.edit_task_id = task.id; this.edit_task_form = build_edit_task_form(task, this.role_label, this.active_owner, this); this.show_edit_task_modal = true; },
  close_edit_task_modal() { this.show_edit_task_modal = false; this.edit_task_id = null; },
  save_edit_task() { if (!this.edit_task_id) return; const task_status = edited_task_status(this.edit_task_form.status_sla); const task_status_class = edited_task_status_class(this.edit_task_form.status_sla); this.tasks = this.tasks.map((task) => task.id !== this.edit_task_id ? task : { ...task, title: this.edit_task_form.task, subtitle: this.edit_task_form.detail, due: this.edit_task_form.due, status: task_status, status_class: task_status_class, source_label: this.edit_task_form.record_module, tags: [this.edit_task_form.linked_record_id, this.edit_task_form.record_module].filter(Boolean) }); this.close_edit_task_modal(); },
  delete_edit_task() { if (!this.edit_task_id) return; if (typeof window !== 'undefined' && !window.confirm('Delete this task?')) return; this.tasks = this.tasks.filter((task) => task.id !== this.edit_task_id); this.close_edit_task_modal(); this.active_drawer_key = null; },
  set_role(role_id) { this.active_role = role_id; this.active_filter = 'all'; },
  set_view_mode(view_mode) { this.view_mode = view_mode; },
  set_filter(filter_id) { this.active_filter = filter_id; },
  open_drawer(drawer_key) { if (!drawer_key) return; this.active_drawer_key = drawer_key; this.active_workflow_item = null; this.$nextTick(() => { const drawer_body = this.$refs.drawerBody; if (drawer_body) drawer_body.scrollTop = 0; }); },
  close_drawer() { this.active_drawer_key = null; this.active_workflow_item = null; }
};
